module.exports = __webpack_public_path__ + "img/blogs_light_blue.3fb8edbe.png";